<template>
  <div class="cf-drop-down-menu-button-wrapper">
    <cf-background-overlay
      v-if="isBackgroundOverlayOpen"
      @close-backgound-overlay="closeDropDownMenu"
    />

    <div
      type="button"
      class="cf-drop-down-menu-button"
      title="Open/Close Navigation Menu"
      @click="openDropDownMenu"
    >
      <div class="cf-icon cf-icon--smedium far fa-bars cf-dropdown-bars" />

      <div
        v-if="hasUnreadMessages"
        class="cf-inbox-notification-badge"
        title="You have unread messages"
      >
        <div class="cf-icon cf-icon--smaller fas fa-exclamation" />
      </div>
    </div>

    <transition name="slide-from-left">
      <drop-down-menu-list v-if="isDropDownMenuOpen">
        <button
          type="button"
          title="Close"
          class="cf-button cf-button--fixed-48 cursor-pointer"
          @click="closeDropDownMenu"
        >
          <span
            aria-hidden="true"
            class="cf-icon cf-icon--smedium cf-icon--black fal fa-times"
          />

          <span class="ada-text">
            Close
          </span>
        </button>

        <default-navigation v-if="isOrderAheadFlow || isOrderAtTableFlow" />

        <pay-at-table-navigation v-if="isPayAtTableFlow" />

        <account-navigation v-if="isAccountManagementEnabled" />

        <template v-if="merchant.linkGroupsByType.Header">
          <custom-navigation
            v-for="group in merchant.linkGroupsByType.Header"
            :key="group.sortOrder"
            :group="group"
          />
        </template>

        <support-navigation />

      </drop-down-menu-list>
    </transition>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import applicationFlows from '@/constants/applicationFlows';

  import CfBackgroundOverlay from '@/view/components/shared/cf-background-overlay/index.vue';

  import AccountNavigation from './account-navigation/index.vue';
  import CustomNavigation from './custom-navigation/index.vue';
  import DefaultNavigation from './default-navigation/index.vue';
  import DropDownMenuList from './drop-down-menu-list/index.vue';
  import PayAtTableNavigation from './pay-at-table-navigation/index.vue';
  import SupportNavigation from './support-navigation/index.vue';


  export default {
    name: 'CfDropDownMenuButton',

    components: {
      AccountNavigation,
      CfBackgroundOverlay,
      CustomNavigation,
      DefaultNavigation,
      DropDownMenuList,
      PayAtTableNavigation,
      SupportNavigation
    },

    provide() {
      return {
        provider_closeDropDownMenu: () => this.closeDropDownMenu()
      };
    },

    props: {
      hamburgerMenuType: {
        type: String,
        default: 'Order'
      }
    },

    data() {
      return {
        isDropDownMenuOpen: false,
        isBackgroundOverlayOpen: false
      };
    },

    computed: {
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),
      ...mapGetters('session', ['applicationFlow', 'unreadInboxMessageCount', 'currentUser']),

      isAccountManagementEnabled() {
        return this.merchant.options.signUpEnabled;
      },

      isOrderAheadFlow() {
        return this.applicationFlow === applicationFlows.ORDER_AHEAD;
      },

      isOrderAtTableFlow() {
        return this.applicationFlow === applicationFlows.ORDER_AT_TABLE;
      },

      isPayAtTableFlow() {
        return this.applicationFlow === applicationFlows.PAY_AT_TABLE;
      },

      hasUnreadMessages() {
        return this.currentUser.isSignedIn && this.unreadInboxMessageCount > 0;
      }
    },

    methods: {
      closeDropDownMenu() {
        this.isDropDownMenuOpen = false;

        this.isBackgroundOverlayOpen = false;
      },

      openDropDownMenu() {
        this.isDropDownMenuOpen = true;

        this.isBackgroundOverlayOpen = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .cf-drop-down-menu-button {
    position: relative;
  }

  .cf-inbox-notification-badge {
    position: absolute;
    bottom: -5px;
    right: -10px;
    width: 18px;
    height: 18px;
    background-color: #dc3545;
    border: 2px solid #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    .cf-icon {
      color: #ffffff;
    }
  }
</style>
